import React, { Component } from 'react';
import './iamExReInfoBox.css';

class IamExReInfoBox extends Component {

  state = {
    expand: true,
  };

  componentDidMount() {

  };

  render() {

    const {users} = this.props;



    const totalUsers = users.length;

    return (
      <div className="IamExReInfoBoxPage">
        <div className="HoverBorder" onClick={this.handleExpand}>
          <h1>All Info</h1>
        </div>
        {this.state.expand &&
          <div>
            <p>Total Users: {totalUsers}</p>
            {[5, 4, 3, 2, 1, 0].map(n => {
              return <p key={n}>Write Access Level {n} Users: {users.filter(user => user.UserAccessLevel.userAccessLevel === n).length}</p>;
            })}
          </div>
        }
      </div>
    );

  };

    handleExpand = () => {
      this.setState({expand: !this.state.expand});
    };

};

export default IamExReInfoBox;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExReport/iamExReContent/iamExReInfoBox/iamExReInfoBox.js